import { render, staticRenderFns } from "./public-top.vue?vue&type=template&id=0c354c69&scoped=true&"
import script from "./public-top.vue?vue&type=script&lang=js&"
export * from "./public-top.vue?vue&type=script&lang=js&"
import style0 from "./public-top.vue?vue&type=style&index=0&id=0c354c69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c354c69",
  null
  
)

export default component.exports